<template>
  <div v-if="!!lang">
    <!-- 기본언어 -->
    <div class="innerItem">
      <p class="innerTitle setLabel">{{locale.setting_language_default}}</p>
      <select class="input" v-model="lang.default" @change="setDefaultLang(lang.default)">
        <option v-for="item in setusable" :key="item.c" :value="item.c">{{ langName(item.c) }}</option>
      </select>
      <div class="mt15">
        <span class="checkbox">
          <input type="checkbox" id="priority_agent_lang" v-model="lang.priorityAgent">
          <label for="priority_agent_lang">{{locale.setting_lang_priority_ua}}</label>
        </span>
      </div>
    </div>
    <!-- //기본언어 -->
    <!-- 사용언어 -->
    <div class="innerItem clear">
      <p class="innerTitle setLabel">
        {{locale.setting_language_use}}
        <i class="sysMessage toLowercase">{{locale.setting_language_info_translate}}</i>
      </p>
      <div class="mt15">
        <span class="checkbox">
          <input type="checkbox" id="hidden_lang_flag" v-model="lang.hiddenLangFlag">
          <label for="hidden_lang_flag">{{locale.setting_language_hidden_flag}}</label>
        </span>
      </div>
      <div class="mt10">
        <button type="button" class="btn btnWhite mt10" :class="{isOpen: !foldLang}" @click="toggleFoldLang">전체 언어 보기</button>
        <button type="button" class="btn mt10 ml10" @click="handleLanguageOrder(true)">사용 언어 순서 변경</button>
      </div>
      <div v-if="!foldLang" class="mt15">
        <!-- 언어 리스트 -->
        <div class="item checkbox langItem"
          v-for="item in lang.info"
          :key="item.c"
          :class="{active: lang.default === item.c, on: lang.usable.includes(item.c)}">
          <input type="checkbox" v-model="lang.usable" :id="item.c" :value="item.c" :disabled="lang.default === item.c">
          <label :for="item.c" @click="isDefault(item.c)">{{ langName(item.c) }}</label>
          <span v-if="lang.usable.includes(item.c)" class="setAutoTranslate">
            <input type="checkbox" v-model="setmanual" :value="item.c" :id="`autoTranslate_${item.c}`" :disabled="lang.default === item.c">
            <label :for="`autoTranslate_${item.c}`">{{item.t ? locale.translate_manual : locale.translate_auto}}</label>
          </span>
        </div>
        <!-- //언어 리스트 -->
      </div>
    </div>
    <!-- //사용언어 -->
    <SetLanguageOrder
      v-if="languageOrder"
      :locale="locale"
      @close="handleLanguageOrder(false)" />
  </div>
</template>

<script>
import SetLanguageOrder from '@/components/Util/SetLanguageOrder'

export default {
  name: 'SetLang',
  props: [
    'locale',
    'lang'
  ],
  components: {
    SetLanguageOrder
  },
  computed: {
    setusable () {
      return this.lang.info.filter(l => l.u)
    },
    setmanual: {
      get () {
        return this.$store.getters['setting/getManualTranslate']
      },
      set (manual) {
        this.$store.commit('setting/setTranslate', manual)
      }
    }
  },
  watch: {
    lang: {
      deep: true,
      handler (data) {
        data.info.forEach(function (x) {
          x.u = data.usable.includes(x.c)
        })
      }
    }
  },
  data () {
    return {
      foldLang: true,
      languageOrder: false
    }
  },
  methods: {
    toggleFoldLang () {
      this.foldLang = !this.foldLang
    },
    langName (c) {
      const code = `lang_${c}`
      return this.locale[code]
    },
    isDefault (code) {
      if (this.lang.default === code) {
        alert(this.locale.validate_setting_lang_default)
      }
    },
    setDefaultLang (code) {
      this.$store.commit('setting/setDefaultLang', code)
    },
    handleLanguageOrder (isOpen) {
      this.languageOrder = isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.langItem {
  float: left;
  width: 50%;
  margin: 0 0 10px 0;
  opacity: 0.6;
  &:nth-of-type(2n+1) {
    clear: left;
  }
  &.on {
    opacity: 1;
  }
}
.btnFold {
  width: 100%;
  padding: 4px 0;
  font-size: 12px;
  color: $color-lgrey;
  border-radius: 4px;
  border: 1px solid $color-lgrey2;
  &:before {
    content: "▼";
  }
  &.isOpen:before {
    content: "▲";
  }
}
.setAutoTranslate {
  display: block;
  margin-top: 5px;
  font-size: 0;
  label {
    display: inline-block;
    padding: 0 1em;
    font-size: 12px;
    color: $color-white;
    border-radius: 0 15px 15px;
    background-color: $color-lgrey;
    &:before,
    &:after {
      display: none;
    }
  }
  :checked + label {
    background-color: $color-green;
  }
}
</style>
